import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { renderQuestionLabel } from '../../utils/common';
var Coverages = function (_a) {
    var label = _a.label, question = _a.question, questionKey = _a.questionKey, helper = _a.helper, value = _a.value, coverages = _a.coverages, protection_amounts = _a.protection_amounts, handleChange = _a.handleChange, hint = _a.hint;
    var checkboxId = "".concat(questionKey, "_checkbox");
    var selectId = "".concat(questionKey, "_select");
    var isChecked = Boolean(value === null || value === void 0 ? void 0 : value.enabled);
    var printMoney = function (number) {
        return "$".concat(number.toLocaleString('en-us', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0
        }));
    };
    var onInputChange = function (e) {
        var isChecked = e.target.checked;
        handleChange({
            enabled: isChecked,
            protection: isChecked ? protection_amounts[0].value : undefined,
            premium: isChecked ? protection_amounts[0].premium : undefined
        });
    };
    var onSelectChanged = function (e) {
        var _a;
        var value = e.target.value;
        var premium = (_a = protection_amounts.find(function (p) { return p.value === value; })) === null || _a === void 0 ? void 0 : _a.premium;
        handleChange({
            enabled: true,
            protection: value,
            premium: premium
        });
    };
    return (React.createElement("div", { className: "border border-[#E9EDF7] rounded-xl w-full overflow-hidden" },
        React.createElement("div", { className: "p-4 sm:p-5 flex flex-col xl:flex-row items-start xl:items-center gap-3 xl:gap-10" },
            React.createElement("div", { className: "flex gap-3 sm:gap-4 flex-1 min-w-0" },
                React.createElement("input", { onChange: onInputChange, type: "checkbox", className: "hidden peer", checked: isChecked, id: checkboxId, name: checkboxId }),
                React.createElement("label", { htmlFor: checkboxId, className: "flex items-center justify-center rounded-md size-5 sm:size-6 bg-white peer-checked:bg-[#15161E] border-2 border-[#15161E] cursor-pointer flex-shrink-0" },
                    React.createElement(FontAwesomeIcon, { icon: faCheck, className: "text-white text-xs sm:text-sm" })),
                React.createElement("div", { className: "flex-1 text-left min-w-0" },
                    React.createElement("h3", { className: "text-[#15161E] font-bold text-base sm:text-lg xl:text-xl leading-5 mb-1" }, renderQuestionLabel(question === null || question === void 0 ? void 0 : question.isHtml, label)),
                    React.createElement("p", { className: "text-xs sm:text-sm" }, helper))),
            isChecked && (React.createElement("div", { className: "flex flex-col gap-1 items-start w-full xl:w-auto" },
                React.createElement("label", { className: "font-semibold text-xs sm:text-sm", htmlFor: selectId },
                    renderQuestionLabel(question === null || question === void 0 ? void 0 : question.isHtml, label),
                    " Protection"),
                React.createElement("select", { className: "w-full xl:w-[280px] px-3 py-2 text-sm sm:text-base text-[#252846] bg-[#F8FAFE] border-2 border-[#E9EDF7] rounded-xl focus:outline-primary", id: selectId, name: selectId, onChange: onSelectChanged }, protection_amounts.map(function (_a) {
                    var caption = _a.caption, value = _a.value;
                    return (React.createElement("option", { key: value, value: value }, caption));
                }))))),
        isChecked && (React.createElement("div", { className: "flex flex-col xl:flex-row gap-2 border-t border-[#E9EDF7]" },
            React.createElement("ul", { className: "flex-1 flex flex-col gap-2 sm:gap-3 p-4 sm:p-5" }, coverages.map(function (coverage) { return (React.createElement("li", { key: coverage.label, 
                // flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3
                className: "flex sm:items-center gap-1 sm:gap-3" },
                React.createElement("div", { className: "flex items-center gap-2 flex-1" },
                    React.createElement("span", { className: "size-4 sm:size-5 flex items-center justify-center flex-shrink-0" },
                        React.createElement(FontAwesomeIcon, { icon: faCheck, className: "text-[#11BDB0] text-xs sm:text-sm" })),
                    React.createElement("span", { className: "text-[10px] sm:text-sm flex-1" }, coverage.label)),
                React.createElement("div", { className: "text-[#15161E] font-semibold text-xs sm:text-sm text-left sm:text-right ml-6 sm:ml-0" },
                    printMoney(coverage.limit),
                    " Limit |",
                    ' ',
                    printMoney(coverage.deductible),
                    " Deductible"))); })),
            React.createElement("div", { className: "flex flex-col items-center justify-center w-full xl:w-[280px] bg-[#F9F9F9] p-4" },
                React.createElement("h3", { className: "text-[#15161E] text-xs sm:text-sm mb-1" }, "Total Premium:"),
                React.createElement("p", { className: "text-[#15161E] text-[28px] sm:text-[32px] md:text-[40px] font-bold" },
                    "$", value === null || value === void 0 ? void 0 :
                    value.premium))))));
};
export default Coverages;
